var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34953 0.47998C7.50313 1.41403 5.54958 2.37434 4 3.18508V8.89896C5.88324 9.84643 7.6497 10.7129 9.34125 11.5972C11.2395 10.6366 12.9346 9.74162 14.6977 8.91966V3.17407C12.8605 2.24836 10.9192 1.2715 9.34953 0.47998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.05176e-05 11.5083V19.1917L9.35613 23.52L18.6405 18.5099V11.5083H16.5206V17.2443L9.28436 21.1501L2.11991 17.8364V11.5083H-3.05176e-05Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRegister);
export default __webpack_public_path__ + "static/media/login_register.8af4f7b13ac9a158d64ff7dd8e76cc4a.svg";
export { ForwardRef as ReactComponent };